













































import Vue from 'vue'
import PasswordField from '@/components/PasswordField.vue'
import { mapActions } from 'vuex'
import { VueForm } from '@/utils/interfaces'
import { AxiosResponse } from 'axios'
import { TokensInterface } from '@/api/Auth/auth.interface'
import { identifyLogrocket, identifySentry } from '@/utils/functions'
import TextButton from '~/components/TextButton.vue'
export default Vue.extend({
  components: {
    appPasswordField: PasswordField,
    TextButton,
  },
  data: function() {
    return {
      rules: {
        requiredUsername: (v: string) => !!v || this.$t('username-required'),
        requiredPassword: (v: string) => !!v || this.$t('password-required'),
      },
      crud: {
        username: '',
        password: '',
      },
      loading: false,
      success: false,
      wrongCredentials: false,
    }
  },
  methods: {
    ...mapActions(['login', 'getProfileInfo']),
    async onLogin(): Promise<void> {
      if (!(this.$refs.form as VueForm).validate()) return
      this.loading = true
      const login: AxiosResponse<TokensInterface> = await this.login(this.crud)
      if (login) {
        this.success = true
        switch (login.status) {
          case 200:
            await this.getProfileInfo()
            this.$i18n.locale = this.$store.getters.profile.lang
            this.$vuetify.lang.current = this.$store.getters.profile.lang
            if (this.$store.getters.profile.role === 'admin') {
              identifyLogrocket(this.$store.getters.profile)
            }
            identifySentry()
            await this.$router.push({ name: 'dashboard' })
            break
          case 201:
            this.$emit('next-login', true) //Indicates the user has already set up 2fa
            await this.$router.push({ name: 'verify' })
            break
          case 202:
            this.$emit('next-login', false) //Indicates the user needs to set up 2fa
            await this.$router.push({ name: 'verify' })
            break
          default:
            break
        }
      } else {
        this.wrongCredentials = true
        setTimeout(() => {
          this.wrongCredentials = false
        }, 1000)
      }
      this.loading = false
    },
  },
})
